module.exports = __webpack_public_path__ + "assets/media/gradient-arrow.21e0ca60.svg";